import api from './api';

export const getMenu = () => {
    return api.get(`/Item/GetMenu`);
}

export const getItems = (PageSize, config) => {
    let errors = [];
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Item/GetItems?PageNumber=${1}&PageSize=${PageSize}`, config);
    }
}

export const deleteItem = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Item/DeleteMenuItem/${value}`, config);
    }
}

export const deleteSubcategory = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Item/DeleteSubCategory/${value}`, config);
    }
}

export const deleteCategory = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Item/DeleteCategory/${value}`, config);
    }
}
export const deleteService = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Item/DeleteService/${value}`, config);
    }
}

export const updateMenu = (menu, config) => {
    let errors = [];
    if (!menu) {
        errors.push('menu');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.put(`/Item/UpdateMenu`, menu, config);
    }
}
